export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7297.c41fa2a5.jpg";